export default __webpack_public_path__ + "static/media/pending.acc1336b.svg";